import Modal from 'react-bootstrap/Modal';

import React, { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import { CircularProgress, List, ListItemButton, ListSubheader } from '@mui/material';
import { PaginationNavigation } from '../../../utils/funtions';


function formatABN(abn) {



    if(abn == 'NOT PROVIDED'){
        return abn
    }

    // Remove any non-digit characters in case the input is not clean
    let str = abn.replace(/\D/g, '');

    // Check if the input is exactly 11 digits, if not, handle as needed
    if (str.length !== 11) {
        console.error("Invalid ABN: ABN must be exactly 11 digits");
        return null;
    }

    // Insert spaces to format as ABN
    return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
}


export default ({setPdfDisplayShow, setSelectedDocument, filteredData, isLoading}) => {

    const itemsPerPage = 8;

    const [currentPage, setCurrentPage] = useState(1)
    
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [currentItems, setCurrentitems] = useState([])


    // Page change handlers
    const nextPage = () => {
        if (currentPage < Math.ceil(filteredData.length / itemsPerPage)) {
            setCurrentPage(oldState => oldState + 1)
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(oldState => oldState - 1)
        }
    };
   

    useEffect(() => {
        
        // Calculate the items for the current page
        let indexOfLastItem = currentPage * itemsPerPage;
        let indexOfFirstItem = indexOfLastItem - itemsPerPage;
        setCurrentitems(filteredData.slice(indexOfFirstItem, indexOfLastItem))

        console.log(currentItems)

    }, [filteredData, currentPage])
    

    return (
        <div style={{ lineHeight: '2vw', marginBottom: '0.5vw', border: '1px solid rgb(255, 255, 255, 0.15)', borderRadius: '1.5vw', textAlign: 'left', padding: '0 0.5vw' }}>
                    

                    {/* table */}
                    <div className="blur" style={{lineHeight: '2vw', marginLeft: '0', marginRight: '0', border: '1px solid rgb(254, 254, 255, 0.15)', borderRadius: '1.2vw', textAlign: 'left'}}>
                        <List className="table table-hover table-dark" style={{ color: 'rgb(0, 15, 30, 0.5)', borderRadius: '1.2vw', fontSize: '0.75vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', margin: 0, padding: 0}}>
                            <ListSubheader style={{fontWeight: 600, fontSize: '0.75vw', lineHeight: '3vw', backgroundColor: 'rgb(0, 15, 30, 0.03)', color: 'rgb(0, 15, 30, 0.7)', borderTopLeftRadius: '1.5vw', borderTopRightRadius: '1.5vw', padding: '0 2vw', display: 'flex', flexDirection: 'row'}}>
                                {/* <div style={{display: 'flex', fontWeight: '600'}}> */}
                                    <div scope="col" name="abn" style ={{padding:'0.1vw 0vw', flex: 3, fontSize: '0.75vw'}}>FILE</div>
                                    <div scope="col" name="client-name" style ={{padding:'0.1vw 0vw', flex: 4, fontSize: '0.75vw'}}>SUGGESTED LOCATION</div>
                                    <div scope="col"  name="period" style ={{padding:'0.1vw 0vw', flex: 1, textAlign:'right', fontSize: '0.75vw'}}>STATUS</div>
                                    {/* <div scope="col"  name="status" style ={{padding:'0.1vw 0vw', flex: 1}}>ACTIONS</div> */}

                                {/* </div> */}
                            </ListSubheader>
                            <div style={{fontSize: '0.6vw', color: 'rgb(0, 15, 30, 0.8)'}}>
                                {currentItems.length > 0 && !isLoading && currentItems.map((row, index) => (
                                    <ListItemButton id={`request-table-item-${row.id}`} key={index} style={{"cursor": "pointer", lineHeight: '2vw', display: 'table-row', display: 'flex', flexDirection: 'row', borderTop: '1px solid rgb(0, 15, 30, 0.05)', fontSize: '0.85vw', padding: '0.5vw 2vw'}}
                                    onClick={() => {

                                            setPdfDisplayShow(true)
                                            console.log(row)
                                            setSelectedDocument(row)
                                        }}
                                    >          


                                        <div scope="col" name="abn" style ={{padding:'0.1vw 0vw', flex: 3, fontSize: '0.75vw'}}>{row.path.replace('/Input/', '')}</div>
                                        <div scope="col" name="client-name" style ={{padding:'0.1vw 0vw', flex: 4, fontSize: '0.75vw'}}>{row.suggested_path? row.suggested_path + '/' + row.suggested_name: 'Pending'}</div>
                                        <div scope="col"  name="period" style ={{padding:'0.1vw 0vw', flex: 1, textAlign: 'right', fontSize: '0.75vw'}}>{row.status.toUpperCase()}</div>
                                        {/* <div scope="col"  name="status" style ={{padding:'0.1vw 0vw', flex: 1}}>{""}</div> */}

                                            {/* <div scope="col" name="abn" style ={{padding:'0.1vw 0vw', fontFamily: "'Consolas', Courier, monospace", letterSpacing: formatABN(row.client_abn) == 'NOT PROVIDED'? '0.15vw': '0.05vw', flex: 3}}>{formatABN(row.client_abn)}</div>
                                            <div scope="col" name="client-name" style ={{padding:'0.1vw 0vw', flex: 6}}>{row.client_name}</div>
                                            <div scope="col"  name="period" style ={{padding:'0.1vw 0vw', flex: 4}}>{new Date(row.start_date).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })} - {new Date(row.end_date).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                                            <div scope="col"  name="version" style ={{padding:'0.1vw 0vw', flex: 3}}>Version {row.version}</div>
                                            <div scope="col"  name="created-on" style ={{padding:'0.1vw 0vw', flex: 3}}>{formatDatetime(row.created_on)}</div>
                        
                                            <div scope="col"  name="status" style ={{padding:'0.1vw 1.5vw', flex: 1.5}}>{row.status == 'done'? 'SUCCESS': (row.status == 'ctlreq'? "SUBMITTED": (row.status == 'processing'? "PROCESSING": "FAILED"))}</div> */}
                                            
                                        {/* </ListItemButton> */}
                                    </ListItemButton>
                                ))}
                                { filteredData.length == 0 && !isLoading &&
                                    <div style={{display: 'flex'}}>
                                        <div style={{flex: 1}}><p style={{color: 'rgb(0, 15, 30, 0.7)', fontSize: '0.7vw', textAlign: 'center', marginTop: '3vw', marginBottom: '3vw'}}>No document found</p></div>
                                    </div>
                                }
                                { filteredData.length == 0 && isLoading &&
                                    <div style={{display: 'flex'}}>
                                        <div style={{flex: 1}}><p style={{color: 'rgb(0, 15, 30, 0.7)', fontSize: '0.7vw',textAlign: 'center', marginTop: '3vw', marginBottom: '3vw'}}><CircularProgress color="inherit" /></p></div>
                                    </div>
                                }
                                
                            </div>
                        </List>
                    </div>


                    <div style={{display: 'flex', flexDirection: 'row', marginTop:'1vw'}}>
                        <div style={{flex: 1, alignSelf: 'center'}}>
                            <p style={{color: 'rgb(0,15,30, 0.6)', fontSize: '0.85vw', marginLeft: '0.5vw', marginBottom: 0}}>Showing {indexOfFirstItem+1} to {filteredData.length>indexOfLastItem?indexOfLastItem:filteredData.length} of {filteredData.length} entries</p>
                        </div>
        
                        {/* arrow buttons */}
                        <PaginationNavigation onNextPage={nextPage} onPrevPage={prevPage}/>
                        
                    </div>


                

        </div>
    )   
}

